import React, { useEffect } from "react";
import { Spacer } from "../../../components";
import { GradientTop } from "../../../components/molecules/v2/InfoCarousel/InfoCarousel.styled";
import useWindowSize from "../../../hooks/useWindowSize";
import { getStaticImg } from "../../../utils/function";
import {
  CategoryDetailBtn,
  CategorySpacing,
  CategoryTitle,
  ContainerSchool,
  ContainerWidth,
  HallOfFameContainer,
  HallOfFameTitle,
  OnGoingTag,
  PlayerContainer,
  PlayerImg,
  PlayerWrapper,
  SectionContainer,
  TagPlayer,
} from "./HomeDetails.styled";
import { useNavigate } from "react-router-dom";
import {
  useFetchEventDetail,
  useFetchEventHallOfFame,
} from "../../../networks";
import moment from "moment";
import useHideStatisticAndHallOfFame from "../../../hooks/useHideStatisticAndHallOfFame";
const FUTSAL_SMA = "Futsal SMA";
const FUTSAL_SMP = "Futsal SMP";
const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;
const HallOfFameCard = ({ slug, soc = false, paddingContainerClassname }) => {
  const navigate = useNavigate();
  const { size } = useWindowSize();
  const { data, isFetching } = useFetchEventHallOfFame(slug);
  const { isHideStatisticOrHOF } = useHideStatisticAndHallOfFame(
    slug,
    data?.data?.data
  );
  const { data: dataEventDetail } = useFetchEventDetail(slug);
  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};
  const hallOfFameData = data?.data?.data ?? {};
  const hallOfFameCategory = Object.keys(hallOfFameData)?.reverse();

  const isMobileView = (size?.width || 0) <= 768;

  const camalize = (str) => {
    if (str)
      return str
        ?.toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  };
  const getOrder = () => {
    const futsalSMA = hallOfFameData[FUTSAL_SMA];
    const futsalSMP = hallOfFameData[FUTSAL_SMP];
    let dataFutsalSMAAnchor = [
      futsalSMA?.["Best Coach"]?.[0],
      futsalSMA?.["MVP"]?.[0],
      futsalSMA?.["Top Scorer"]?.[0],
      futsalSMA?.["Best Goalkeeper"]?.[0],
    ]?.sort(
      (a, b) => parseInt(a?.order_position) - parseInt(b?.order_position)
    );

    dataFutsalSMAAnchor = dataFutsalSMAAnchor?.map((val) => val?.category);
    let dataFutsalSMPAnchor = [
      futsalSMP?.["Best Coach"]?.[0],
      futsalSMP?.["MVP"]?.[0],
      futsalSMP?.["Top Scorer"]?.[0],
      futsalSMP?.["Best Goalkeeper"]?.[0],
    ]?.sort(
      (a, b) => parseInt(a?.order_position) - parseInt(b?.order_position)
    );

    dataFutsalSMPAnchor = dataFutsalSMPAnchor?.map((val) => val?.category);
    const dataFutsalSMA = dataFutsalSMAAnchor?.map((val) => {
      return futsalSMA?.[val];
    });
    const dataFutsalSMP = dataFutsalSMPAnchor?.map((val) => {
      return futsalSMP?.[val];
    });

    return { dataFutsalSMA, dataFutsalSMP };
  };
  const collectionData = getOrder();

  const SectionWrapperCond = ({ cond, children }) => {
    if (!cond) {
      return (
        <ContainerWidth
          className={paddingContainerClassname}
          style={{ marginLeft: "auto", marginRight: "auto" }}
        >
          <SectionContainer backgroundColor={"transparent"}>
            {children}
          </SectionContainer>
        </ContainerWidth>
      );
    } else
      return (
        <Spacer
          marginLeft={"24px"}
          marginBottom={"32px"}
          className={paddingContainerClassname}
        >
          {children}
        </Spacer>
      );
  };

  const PlayerCategory = ({
    category,
    firstName,
    lastName,
    tagName,
    schoolName,
    schoolImg,
    playerImg = getStaticImg("/illustration/default-player.svg"),
    index,
    bgImg = getStaticImg("/illustration/swoosh-frame-carding.svg"),
    totalGoal,
    updatedAt,
    isOnGoing,
    onClick,
  }) => {
    const categoryImgLabel = String(category)?.toLowerCase()?.replace(" ", "-");
    const fontStyle = isMobileView
      ? {
          medium: "14px",
          small: "12px",
          large: "20px",
          extraSmall: "8px",
          normal: "10px",
          extraLarge: "24px",
        }
      : {
          medium: "17px",
          small: "13.5px",
          large: "24.9px",
          extraSmall: "9.8px",
          normal: "12.32px",
          extraLarge: "29.5px",
        };

    return (
      <PlayerContainer
        onClick={onClick}
        backgroundImage={bgImg}
        marginLeft={index === 1 ? "16px" : 0}
        marginRight={index > 0 ? "16px" : 0}
      >
        <Spacer marginLeft={"16px"}>
          <div id="player-label">
            <img
              src={getStaticImg(`/illustration/${categoryImgLabel}.svg`)}
              alt={categoryImgLabel}
              style={{ marginRight: 4, width: 24 }}
            />
            <CategoryTitle fontSize={fontStyle?.medium}>
              {category}
            </CategoryTitle>
            {category === "Top Scorer" && isOnGoing ? (
              <OnGoingTag>{"Ongoing"}</OnGoingTag>
            ) : (
              <></>
            )}
          </div>

          <Spacer marginTop={"16px"} />
          {firstName ? (
            <CategoryTitle fontSize={fontStyle?.medium}>
              {firstName}
            </CategoryTitle>
          ) : (
            <>
              <div className="h-[14px]" />
              <Spacer marginBottom={"8px"} />
            </>
          )}
          <Spacer />
          <CategoryTitle fontSize={fontStyle?.large}>{lastName}</CategoryTitle>
          <Spacer marginTop={"8px"} />
          <div style={{ display: "inline-flex" }}>
            {tagName && (
              <div style={{ width: "20%" }}>
                {tagName && (
                  <TagPlayer>
                    <CategoryTitle fontSize={fontStyle?.small}>
                      {tagName}
                    </CategoryTitle>
                  </TagPlayer>
                )}
                {totalGoal && (
                  <>
                    <Spacer marginTop={"16px"} />
                    <CategoryTitle
                      fontSize={fontStyle?.normal}
                      fontWeight="normal"
                    >
                      {"Total Gol:"}
                    </CategoryTitle>
                    <Spacer />
                    <CategoryTitle
                      fontSize={fontStyle?.extraLarge}
                      fontWeight="bold"
                    >
                      {totalGoal}
                    </CategoryTitle>
                  </>
                )}
                {updatedAt && (
                  <div
                    style={{
                      lineHeight: 1,
                      marginTop: isMobileView ? "100%" : "90%",
                    }}
                  >
                    <CategoryTitle
                      fontSize={fontStyle?.extraSmall}
                      fontWeight="normal"
                    >
                      {"Updated:"}
                    </CategoryTitle>
                    <Spacer />
                    <CategoryTitle
                      fontSize={fontStyle?.extraSmall}
                      fontWeight="bold"
                    >
                      {updatedAt}
                    </CategoryTitle>
                  </div>
                )}
              </div>
            )}

            <div
              style={{
                width: tagName?.length ? "90%" : "100%",
                marginLeft: tagName?.length ? 0 : isMobileView ? 40 : 53,
              }}
            >
              <PlayerImg
                src={playerImg}
                alt="player"
                height={
                  isMobileView
                    ? tagName?.length
                      ? "162px"
                      : "175px"
                    : tagName?.length
                    ? "205.76px"
                    : "222px"
                }
                transform={
                  tagName?.length
                    ? "rotate(0.0001deg)"
                    : isMobileView
                    ? "translateY(6px)"
                    : "translateY(8px)"
                }
              />
            </div>
          </div>
        </Spacer>

        <ContainerSchool>
          <img
            src={imgPath + schoolImg}
            alt="badge"
            style={{ width: 26, height: 21, objectFit: "contain" }}
          />
          <span>{schoolName}</span>
        </ContainerSchool>
      </PlayerContainer>
    );
  };

  if (isHideStatisticOrHOF) return null;

  return (
    <div id="hof">
      {soc ? (
        <>
          <div
            className=""
            style={{
              background: `url(${getStaticImg(
                "/illustration/sharp-swoosh.svg"
              )}) no-repeat left top, url(${getStaticImg(
                "/illustration/sharp-swoosh2.svg"
              )}) #1f2d3d no-repeat right bottom`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left top, right bottom",
              width: "100vw",
              height: "100vh",
            }}
          >
            <Spacer>
              <SectionWrapperCond cond={isMobileView}>
                <img
                  className="w-80 md:w-96 h-auto mt-[30%] md:mt-24"
                  src={getStaticImg("/illustration/hof-soc-title.svg")}
                  alt="hall-of-fame-title"
                />
                <>
                  <PlayerWrapper>
                    <Spacer marginTop={"36px"} />
                    {collectionData?.dataFutsalSMA?.map((dataVal, i) => {
                      const val = dataVal?.[0] ?? {};

                      const isTopScorerCategory =
                        val?.category === "Top Scorer";

                      if (!Object.keys(val)?.length) {
                        const defaultCatOrder = [
                          "Top Scorer",
                          "MVP",
                          "Best Goalkeeper",
                          "Best Coach",
                        ];
                        return (
                          <PlayerCategory
                            index={i}
                            bgImg={getStaticImg(
                              "/illustration/swoosh-frame-carding.svg"
                            )}
                            category={defaultCatOrder[i]}
                            firstName={""}
                            lastName={
                              defaultCatOrder[i] === "Best Coach"
                                ? "Pelatih"
                                : "Pemain"
                            }
                            tagName={null}
                            schoolName={"SMA/SMK"}
                            schoolImg={dataEvent?.key_visual}
                            onClick={() =>
                              navigate(
                                `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                              )
                            }
                          />
                        );
                      } else
                        return (
                          <PlayerCategory
                            index={i}
                            category={val?.category}
                            firstName={val?.first_name}
                            lastName={val?.last_name}
                            tagName={val?.tag_name}
                            schoolName={val?.school_name}
                            playerImg={imgPath + val?.player_image}
                            totalGoal={
                              isTopScorerCategory ? val?.goal_total : undefined
                            }
                            schoolImg={val?.school_logo}
                            updatedAt={
                              isTopScorerCategory
                                ? moment(val?.updated_at).format("DD MMMM YYYY")
                                : null
                            }
                            isOnGoing={val?.is_ongoing}
                            onClick={() =>
                              navigate(
                                `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                              )
                            }
                          />
                        );
                    })}
                  </PlayerWrapper>
                  {/* <div className="flex justify-center pr-[24px] mt-12 w-full">
                    <button
                      className="w-[327px] h-[44px] bg-[#00BCF1] rounded-[40px] text-white border-transparent font-bold"
                      onClick={() =>
                        navigate(
                          `/soc/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                        )
                      }
                    >
                      Detail Statistik
                    </button>
                  </div> */}

                  <Spacer marginBottom={"32px"} />
                </>
              </SectionWrapperCond>
            </Spacer>
          </div>
        </>
      ) : (
        <HallOfFameContainer
          backgroundImage={`url(${getStaticImg(
            "/illustration/sharp-swoosh.svg"
          )}), url(${getStaticImg("/illustration/sharp-swoosh2.svg")}) #1f2d3d`}
        >
          {/* {!isMobileView && <GradientTop />} */}
          {/* <TopSwoosh /> */}
          <Spacer>
            <SectionWrapperCond cond={isMobileView}>
              <HallOfFameTitle
                src={getStaticImg("/illustration/hall-of-fame-title.svg")}
                alt="hall-of-fame-title"
              />
              <>
                <CategorySpacing>
                  <CategoryTitle>{FUTSAL_SMA}</CategoryTitle>
                  <CategoryDetailBtn
                    onClick={() =>
                      navigate(
                        `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                      )
                    }
                  >
                    <CategoryTitle fontWeight={"normal"} fontSize={"14px"}>
                      {"Detail Statistik"}
                    </CategoryTitle>

                    <img
                      src={getStaticImg("/illustration/sa-arrow-right.svg")}
                      alt="arrow-right"
                      style={{ marginLeft: 4 }}
                    />
                  </CategoryDetailBtn>
                </CategorySpacing>
                <PlayerWrapper>
                  <Spacer marginTop={"16px"} />
                  {collectionData?.dataFutsalSMA?.map((dataVal, i) => {
                    const val = dataVal?.[0] ?? {};

                    const isTopScorerCategory = val?.category === "Top Scorer";

                    if (!Object.keys(val)?.length) {
                      const defaultCatOrder = [
                        "Top Scorer",
                        "MVP",
                        "Best Goalkeeper",
                        "Best Coach",
                      ];
                      return (
                        <PlayerCategory
                          index={i}
                          bgImg={getStaticImg(
                            "/illustration/swoosh-frame-carding.svg"
                          )}
                          category={defaultCatOrder[i]}
                          firstName={""}
                          lastName={
                            defaultCatOrder[i] === "Best Coach"
                              ? "Pelatih"
                              : "Pemain"
                          }
                          tagName={null}
                          schoolName={"SMA/SMK"}
                          schoolImg={dataEvent?.key_visual}
                          onClick={() =>
                            navigate(
                              `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                            )
                          }
                        />
                      );
                    } else
                      return (
                        <PlayerCategory
                          index={i}
                          category={val?.category}
                          firstName={val?.first_name}
                          lastName={val?.last_name}
                          tagName={val?.tag_name}
                          schoolName={val?.school_name}
                          playerImg={imgPath + val?.player_image}
                          totalGoal={
                            isTopScorerCategory ? val?.goal_total : undefined
                          }
                          schoolImg={val?.school_logo}
                          updatedAt={
                            isTopScorerCategory
                              ? moment(val?.updated_at).format("DD MMMM YYYY")
                              : null
                          }
                          isOnGoing={val?.is_ongoing}
                          onClick={() =>
                            navigate(
                              `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`
                            )
                          }
                        />
                      );
                  })}
                </PlayerWrapper>
                <Spacer marginBottom={"32px"} />
              </>
              <>
                <CategorySpacing>
                  <CategoryTitle>{FUTSAL_SMP}</CategoryTitle>
                  <CategoryDetailBtn
                    onClick={() =>
                      navigate(
                        `/${slug}/klasemen-pertandingan?activeCard=futsalsmpGroup&tab=statistic`
                      )
                    }
                  >
                    <CategoryTitle fontWeight={"normal"} fontSize={"14px"}>
                      {"Detail Statistik"}
                    </CategoryTitle>
                    <img
                      src={getStaticImg("/illustration/sa-arrow-right.svg")}
                      alt="arrow-right"
                      style={{ marginLeft: 4 }}
                    />
                  </CategoryDetailBtn>
                </CategorySpacing>
                <PlayerWrapper>
                  <Spacer marginTop={"16px"} />
                  {collectionData?.dataFutsalSMP?.map((dataVal, i) => {
                    const val = dataVal?.[0] ?? {};
                    const isTopScorerCategory = val?.category === "Top Scorer";

                    if (!Object.keys(val)?.length) {
                      const defaultCatOrder = [
                        "Top Scorer",
                        "MVP",
                        "Best Goalkeeper",
                        "Best Coach",
                      ];
                      return (
                        <PlayerCategory
                          index={i}
                          bgImg={getStaticImg(
                            "/illustration/swoosh-frame-carding-green.svg"
                          )}
                          category={defaultCatOrder[i]}
                          firstName={""}
                          lastName={
                            defaultCatOrder[i] === "Best Coach"
                              ? "Pelatih"
                              : "Pemain"
                          }
                          tagName={null}
                          schoolName="SMP"
                          schoolImg={dataEvent?.key_visual}
                          onClick={() =>
                            navigate(
                              `/${slug}/klasemen-pertandingan?activeCard=futsalsmpGroup&tab=statistic`
                            )
                          }
                        />
                      );
                    } else
                      return (
                        <PlayerCategory
                          index={i}
                          bgImg={getStaticImg(
                            "/illustration/swoosh-frame-carding-green.svg"
                          )}
                          category={val?.category}
                          firstName={val?.first_name}
                          lastName={val?.last_name}
                          tagName={val?.tag_name}
                          schoolName={val?.school_name}
                          playerImg={imgPath + val?.player_image}
                          totalGoal={
                            isTopScorerCategory ? val?.goal_total : undefined
                          }
                          schoolImg={val?.school_logo}
                          updatedAt={
                            isTopScorerCategory
                              ? moment(val?.updated_at).format("DD MMMM YYYY")
                              : null
                          }
                          isOnGoing={val?.is_ongoing}
                          onClick={() =>
                            navigate(
                              `/${slug}/klasemen-pertandingan?activeCard=futsalsmpGroup&tab=statistic`
                            )
                          }
                        />
                      );
                  })}
                </PlayerWrapper>
              </>
            </SectionWrapperCond>
          </Spacer>
        </HallOfFameContainer>
      )}
    </div>
  );
};

export default HallOfFameCard;
